import { meetingOptionalAttendee } from './MeetingDetails.locstring.json';
import loc from 'owa-localize';
import MeetingDetailsLocation from './MeetingDetailsLocation';
import MeetingDetailsTime from './MeetingDetailsTime';
import { observer } from 'mobx-react-lite';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { MailIcons } from 'owa-mail-icons';
import { MeetingForwardSenderPersona } from 'owa-mail-sender-persona-view';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import MeetingResponseMessageType from 'owa-service/lib/contract/MeetingResponseMessageType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import * as React from 'react';

const styles = require('./MeetingDetails.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MeetingDetailsProps {
    item: MeetingRequestMessageType | MeetingResponseMessageType | MeetingCancellationMessageType;
    isForward?: boolean;
}

const MeetingDetails = observer(function MeetingDetails(props: MeetingDetailsProps) {
    const { item, isForward } = props;

    const conditionalDetailsStyles = {
        cancelled: item.ItemClass.match(/^ipm\.schedule\.meeting\.canceled/i),
    };
    const userOptional =
        item.CcRecipients &&
        item.CcRecipients.some(
            cc =>
                cc.EmailAddress.toLowerCase() ===
                getUserConfiguration().SessionSettings.UserEmailAddress.toLowerCase()
        );

    const meetingRequest = item as MeetingRequestMessageType;

    return (
        <div className={classNames(styles.detailsContainer, { isForward: isForward })}>
            <div className={classNames(styles.subject, styles.detailsRow)}>
                <Icon
                    className={classNames(styles.icon, styles.subjectIcon)}
                    iconName={ControlIcons.Event}
                    style={{ marginTop: '2px' }}
                />
                {item.Subject}
            </div>
            {userOptional && !isForward && (
                <div className={styles.detailsRow}>
                    <Icon
                        className={classNames(styles.icon, styles.clockIcon)}
                        iconName={MailIcons.UserOptional}
                    />
                    <span className={classNames(conditionalDetailsStyles)}>
                        {loc(meetingOptionalAttendee)}
                    </span>
                </div>
            )}
            {isForward && (
                <div className={styles.detailsRow}>
                    <Icon
                        className={classNames(styles.icon, styles.personIcon)}
                        iconName={ControlIcons.Contact}
                    />
                    <MeetingForwardSenderPersona
                        message={item}
                        senderPersonaClassName={styles.forwardSenderPersona}
                    />
                </div>
            )}
            <MeetingDetailsTime item={meetingRequest} />
            <MeetingDetailsLocation item={meetingRequest} />
        </div>
    );
});
export default MeetingDetails;
